import * as React from "react";
import Container from "@mui/material/Container";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography/Typography";
import { useNavigate, useParams } from "react-router-dom";
import firebase from "../../firebase/firebase";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import TextField from "@mui/material/TextField/TextField";
import { Paper, IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { HelpOutline } from "@mui/icons-material";
import ScrollToTop from "../../utils/scrollTop";
import NumberFormat from "../../helpers/number-format";

export default function PaymentAgreedAmount() {
	let { contractId, projectId } = useParams();
	const navigator = useNavigate();
	const [amount, setAmount] = React.useState();
	const [type, setType] = React.useState();
	const [open, setOpen] = React.useState(false);
	const [dataLoaded, setDataLoaded] = React.useState(false);
	const [minimumAmount, setMinimumAmount] = React.useState(0);
	const [maximumAmount, setMaximumAmount] = React.useState(0);
	const updateContractAmount = async () => {
		const contractRef = firebase
			.firestore()
			.collection("contracts")
			.doc(contractId);
		await contractRef.update({
			agreedAmount: amount,
		});
		navigator(`/investor/payments/escrow-bank-details/${contractId}`, {
			state: { amount, projectId },
		});
	};
	React.useEffect(() => {
		let unsubscribe;
		if (!dataLoaded) {
			unsubscribe = firebase
				.firestore()
				.collection("projects")
				.doc(projectId)
				.get()
				.then((d) => {
					let budget = d.data()?.budget;
					let min = d.data()?.contract?.minimumInvestment;
					let max = d.data()?.contract?.maximumInvestment;
					if (
						d.data()?.contract &&
						d.data()?.contract?.howMuchInvestors &&
						parseInt(d.data()?.contract?.howMuchInvestors) > 1
					) {
						setType("PartialFunded");
						setAmount(0);
						setMinimumAmount(min);
						setMaximumAmount(max);
					} else {
						setType("FullyFunded");
						setAmount(budget);
					}
				});
			setDataLoaded(true);
		}
	}, [amount]);

	const handleOpen = () => {
		setOpen(!open);
	};
	return (
		<React.Fragment>
			<ScrollToTop/>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar showBar={true}/>*/}
			<Container
				maxWidth="fullWidth"
				sx={{
					backgroundColor: "#E3E8F0",
					paddingY: 8,
					mb: 8,
					textAlign: "left",
				}}>
				<Container maxWidth="lg">
					<Typography variant={"h4"} sx={{ pl: 2 }} color={"primary"}>
						PAYMENT
					</Typography>
				</Container>
			</Container>
			<Container maxWidth="lg" sx={{ textAlign: "left" }}>
				<Stack direction={"row"} spacing={10}>
					<Box sx={{ flex: 0.75, pl: 2 }}>
						<Stack direction={"row"} spacing={5}>
							<Box
								sx={{
									flex: 2,
									p: 2,
								}}>
								<Grid container spacing={2}>
									{type === "FullyFunded" ? (
										<>
											<Grid item xs={7}>
												<Typography
													variant={"body1"}
													color="common.black">
													INVESTMENT AMOUNT
												</Typography>
											</Grid>
											<Grid item xs={5}>
												<Typography
													variant={"body1"}
													color={"primary"}>
													${Intl.NumberFormat().format(amount)}
												</Typography>
											</Grid>
										</>
									) : (
										<>
											<Grid item xs={7}>
												<Typography
													variant={"body1"}
													color={"primary"}>
													INSERT AMOUNT AGREED IN THE
													CONTRACT
												</Typography>
											</Grid>
											<Grid item xs={5}>
												<TextField
													defaultValue={minimumAmount}
													variant={"outlined"}
													size={"medium"}
													type={"number"}
													error={
														amount <
															minimumAmount ||
														amount > maximumAmount
													}
													helperText={
														amount <
															minimumAmount ||
														amount > maximumAmount
															? "Please Enter a valid amount"
															: ""
													}
													onChange={(e) => {
														if (
															e.target.value ===
															""
														) {
															setAmount(0);
														} else {
															setAmount(
																e.target.value
															);
														}
													}}
													sx={{ borderRadius: "0px" }}
												/>
											</Grid>
										</>
									)}
								</Grid>

								<Grid container spacing={2}>
									<Grid item xs={2} mt={6}>
										<Typography
											variant={"body1"}
											color="common.black">
											TAOST FEE{" "}

										</Typography>
									</Grid>
									<Grid item xs={5} mt={5}>

										<Tooltip
										componentsProps={{
											tooltip: {
												color: '#363636',
											  sx: {
												fontSize: 16 ,
												color: '#204488',
												maxWidth: "296px",
												  bgcolor: '#E3E8F0',
												'& .MuiTooltip-arrow': {
												  color: '#E3E8F0',
												},
											  },
											},
										  }} title={"Taost collects 5% commission fee on the amount raised. Taost will refund the total investment amount, including the 5% fee, in the case when funding amount did not reach the required threshold"} arrow sx={{width:"30px"}}><IconButton><HelpOutline sx={{color:"#204488"}}/></IconButton></Tooltip>
									</Grid>
									<Grid item xs={5} mt={6}>
										<Typography
											variant={"body1"}
											color="common.black">
													${Intl.NumberFormat().format((
												parseFloat(amount) * 0.05
											).toFixed(1))}
											 
											
										</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={2}>
									<Grid item xs={7} mt={6}>
										<Typography
											variant={"body1"}
											color="common.black">
											TOTAL AMOUNT
										</Typography>
									</Grid>
									<Grid item xs={5} mt={6}>
										<Typography
											variant={"body1"}
											color="common.black">
											${Intl.NumberFormat().format((
											
												parseFloat(amount) * 0.05 +
												parseFloat(amount)
											).toFixed(1))}
										</Typography>
									</Grid>
								</Grid>
							</Box>
						</Stack>
					</Box>
					{type && type === "FullyFunded" ? (
						<Box
							sx={{
								flex: 0.25,
								backgroundColor: "#E3E8F0",
								p: 2,
							}}>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{ textAlign: "center" }}>
								Full investor
							</Typography>

							<Typography
								variant={"body2"}
								color={"secondary"}
								sx={{ textAlign: "center", mt: 3, mb: 2 }}>
								You are a Full investor in this project. Insert
								the amount agreed between you and the creator.
							</Typography>
						</Box>
					) : (
						<Box
							sx={{
								flex: 0.25,
								backgroundColor: "#E3E8F0",
								p: 2,
							}}>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{ textAlign: "center" }}>
								Partial investor
							</Typography>

							<Typography
								variant={"body2"}
								color={"secondary"}
								sx={{ textAlign: "center", mt: 3, mb: 2 }}>
								You are a partial investor in this project.
								Insert the amount agreed between you and the
								creator.
							</Typography>
						</Box>
					)}
				</Stack>
				<Stack
					direction={"row"}
					justifyContent="center"
					alignItems="center"
					sx={{ mt: 10 }}>
					<Button
						variant={"contained"}
						sx={{ px: 7 }}
						disabled={!amount && (type != "FullyFunded" || amount)}
						onClick={updateContractAmount}>
						Next
					</Button>
				</Stack>
			</Container>
		</React.Fragment>
	);
}
